/**
 * Helper function to ensure that switch statements are exhaustive.
 *
 * Typically you put this function in the default case, passing the test expression
 * in the switch statement. Omitting a case will yield a type error.
 */

export function assertUnreachable(_: never): never {
  throw new Error("Unreachable code point: " + _);
}
